module.exports = __webpack_public_path__ + "static/media/arman.bc80e7a1.jpeg";